// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_spin_to_win = /** @type {(inputs: {}) => string} */ () => {
	return `Spin to win`
};

const de_widget_spin_to_win = /** @type {(inputs: {}) => string} */ () => {
	return `Drehen zum Gewinnen`
};

const es_widget_spin_to_win = /** @type {(inputs: {}) => string} */ () => {
	return `Gira para ganar`
};

const fr_widget_spin_to_win = /** @type {(inputs: {}) => string} */ () => {
	return `Tourner pour gagner`
};

const fi_widget_spin_to_win = /** @type {(inputs: {}) => string} */ () => {
	return `Pyöritä voittaaksesi`
};

const hi_widget_spin_to_win = /** @type {(inputs: {}) => string} */ () => {
	return `जीतने के लिए स्पिन करें`
};

const ja_widget_spin_to_win = /** @type {(inputs: {}) => string} */ () => {
	return `回して勝利`
};

const nl_widget_spin_to_win = /** @type {(inputs: {}) => string} */ () => {
	return `Draai om te winnen`
};

const pt_widget_spin_to_win = /** @type {(inputs: {}) => string} */ () => {
	return `Gire para ganhar`
};

const ro_widget_spin_to_win = /** @type {(inputs: {}) => string} */ () => {
	return `Învârte pentru a câștiga`
};

const th_widget_spin_to_win = /** @type {(inputs: {}) => string} */ () => {
	return `หมุนเพื่อชนะ`
};

const ur_widget_spin_to_win = /** @type {(inputs: {}) => string} */ () => {
	return `گھما کر جیتیں`
};

const zh_hant1_widget_spin_to_win = /** @type {(inputs: {}) => string} */ () => {
	return `旋轉獲勝`
};

const da_widget_spin_to_win = /** @type {(inputs: {}) => string} */ () => {
	return `Drej for at vinde`
};

const it_widget_spin_to_win = /** @type {(inputs: {}) => string} */ () => {
	return `Gira per vincere`
};

const vn_widget_spin_to_win = /** @type {(inputs: {}) => string} */ () => {
	return `Quay để thắng`
};

const ko_widget_spin_to_win = /** @type {(inputs: {}) => string} */ () => {
	return `돌려서 당첨`
};

const tr_widget_spin_to_win = /** @type {(inputs: {}) => string} */ () => {
	return `Çevir ve kazan`
};

const lv_widget_spin_to_win = /** @type {(inputs: {}) => string} */ () => {
	return `Grieziet, lai uzvarētu`
};

const ar_widget_spin_to_win = /** @type {(inputs: {}) => string} */ () => {
	return `أدر للفوز`
};

const bs_widget_spin_to_win = /** @type {(inputs: {}) => string} */ () => {
	return `Vrtite da biste dobili`
};

const sl_widget_spin_to_win = /** @type {(inputs: {}) => string} */ () => {
	return `Zavrtite za zmago`
};

const id_widget_spin_to_win = /** @type {(inputs: {}) => string} */ () => {
	return `Putar untuk menang`
};

const sv_widget_spin_to_win = /** @type {(inputs: {}) => string} */ () => {
	return `Snurra för att vinna`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_spin_to_win = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_spin_to_win(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_spin_to_win", locale)
	if (locale === "en") return en_widget_spin_to_win(inputs)
	if (locale === "de") return de_widget_spin_to_win(inputs)
	if (locale === "es") return es_widget_spin_to_win(inputs)
	if (locale === "fr") return fr_widget_spin_to_win(inputs)
	if (locale === "fi") return fi_widget_spin_to_win(inputs)
	if (locale === "hi") return hi_widget_spin_to_win(inputs)
	if (locale === "ja") return ja_widget_spin_to_win(inputs)
	if (locale === "nl") return nl_widget_spin_to_win(inputs)
	if (locale === "pt") return pt_widget_spin_to_win(inputs)
	if (locale === "ro") return ro_widget_spin_to_win(inputs)
	if (locale === "th") return th_widget_spin_to_win(inputs)
	if (locale === "ur") return ur_widget_spin_to_win(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_spin_to_win(inputs)
	if (locale === "da") return da_widget_spin_to_win(inputs)
	if (locale === "it") return it_widget_spin_to_win(inputs)
	if (locale === "vn") return vn_widget_spin_to_win(inputs)
	if (locale === "ko") return ko_widget_spin_to_win(inputs)
	if (locale === "tr") return tr_widget_spin_to_win(inputs)
	if (locale === "lv") return lv_widget_spin_to_win(inputs)
	if (locale === "ar") return ar_widget_spin_to_win(inputs)
	if (locale === "bs") return bs_widget_spin_to_win(inputs)
	if (locale === "sl") return sl_widget_spin_to_win(inputs)
	if (locale === "id") return id_widget_spin_to_win(inputs)
	if (locale === "sv") return sv_widget_spin_to_win(inputs)
	return "widget_spin_to_win"
};